module.exports = __webpack_public_path__ + "media/newstyle/images/info-red-573cf833fd2d5c407bfb47de6025bd30.svg";